import config from '@/config'
import api from '@/api'
let o = {}
o.createObj = function (val) {
  let o = {
    certTempId: val.form.certList[0].id
  }
  var r = []
  for (let i = 0; i < val.people.length; i++) {
    let o = val.people[i]
    let ro = {};
    ro.itemId = o.id
    if (o.uitype == '01') {
      ro.itemType = '99'
    } else if (o.uitype == '02') {
      ro.itemType = '98'
    } else if (o.uitype == '03') {
      ro.itemType = '05'
    } else if (o.tagType) {
      ro.itemType = '07'
    }
    r.push(ro)
  }
  o.certLibraryList = r
  return o
}
o.send = function (o) {
  var p = this.createObj(o)
  // console.log(p)
  return new Promise(function (resolve, reject) {
    api.post(config.bylApiPath, '/cert/batchGenerate', p, r => {
      resolve(r.data)
    })
  })
}
export default o



// WEBPACK FOOTER //
// ./src/utils/sendCert.js